import React from "react";
import { buildHeaderArr, buildDataArr, makeHeader, makeStockHeader/* , settings, strings */ } from "./Utils";
import Pagination from "./Pagination";
import { connect } from "react-redux";
import {
  updatePage,
  selectSort,
  updateResults,
  SearchModes
} from "../../store/actions";
import StickyTable from "./StickyTable";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: props.page,
    };
  }

  render() {
    const { data, columns, pages, loading, pageSize, page, sorted, searchExecuted, activeSearchMode } = this.props;
    const shouldRender = !!(Array.isArray(data) && data.length && searchExecuted && activeSearchMode !== SearchModes.ALTERNATIVE);
    return shouldRender && (
      <>
        <StickyTable
          page={page}
          sorted={sorted}
          PaginationComponent={Pagination}
          getPaginationProps={() => {
            return {
              count: this.props.count,
            };
          }}
          columns={columns}
          loading={loading}
          data={data}
          pages={pages}
          pageSize={pageSize}
          manual
          onPageChange={(pageIndex) => {
            this.props.updatePage(pageIndex);
            this.props.updateResults(true);
          }}
          onSortedChange={(newSorted, column, shiftKey) => {
            this.props.selectSort(newSorted);
            this.props.updateResults(true);
          }}
          className="-striped"></StickyTable>
      </>
    );
  }
}

const getColumns = (header, settings, strings) => {
  const isMobile = window.innerWidth < 768;
  let baseColumn = {
    Header: makeHeader(strings['STRING:PART_NO']),
    accessor: "title",
    Cell: row => (
      <div className={'product-link'}>
        <a href={row.value.link} className="product-link__product">
          {row.value.value}
        </a>
       { // Conditionally display the product label according to the data coming from Utils.js
        row.value.product_state.length ?
        row.value.product_state.map((productState, i) => {
          return <span key={i} className={`product-label ${productState.stateClass}`}>{productState.stateText}</span>
        }) : null
       }
      </div>
    ),
    width: 190,
    fixed: isMobile ? null : "left"
  };
  let dataSheet = {
    Header: makeStockHeader(strings['STRING:DATA_SHEET']),
    accessor: "title",
    Cell: row => {
      const dataSheet = row.value.data_sheet;
      if (dataSheet.length > 0) {
        return dataSheet.map((item, i) => {
          return (
            <div key={i} className="data-sheet-wraper">
              <a target="_blank"
                 href={item}
                 className="data-sheet-wraper__link"></a>
            </div>
          )
        });
      }
      else {
        return null
      }
    },
    width: 110,
    fixed: isMobile ? null : "left"
  };
  let stockColumn = {
    Header: makeStockHeader(strings['STRING:SEARCH_IN_STOCK']),
    accessor: "title",
    Cell: row => {
      if (row.value.nostocksearch == true) {
        return <></>
      }
      else {
        return <div className="product-stock-link">
          <a target="_blank"
             href={settings.stockSearchBasePath + '?part=' + row.value.model_id}
             className="product-stock-link__stock"></a>
        </div>
      }
    },
    width: 90,
    fixed: isMobile ? null : "left"
  };
  return [
    baseColumn,
    dataSheet,
    stockColumn,
    ...header.map((attribute) => {
      return {
        Header: makeHeader(attribute[1]),
        accessor: attribute[0],
        width: 155,
        Cell: props => {
          if (props.value) {
            return <span title={props.value.rendered} className={props.value.unit ? 'with-unit' : ''}>{props.value.rendered}</span>
          }
          return <></>
        }
      }
    })
  ];
};

const mapStateToProps = (state, props) => {
  
  // get component props
  const { settings, strings } = props;

  const removedAttributeFilters = state.parameters.removedAttributeFilters;
  const columns = getColumns(buildHeaderArr(state.results.attributes, removedAttributeFilters, state.results.result), settings, strings);
  const data = buildDataArr(state.results.result, removedAttributeFilters);
  const pageSize = state.results.count - state.parameters.page*20;// ???
  return {
    searchExecuted: state.results.searchExecuted,
    activeSearchMode: state.parameters.activeSearchMode,
    data: data,
    sorted: state.parameters.sort,
    page: state.parameters.page,
    loading: state.results.isFetching,
    columns: columns,
    count: state.results.count,
    pages: Math.ceil(state.results.count/20),
    pageSize: ((pageSize < 20) ? pageSize : 20),
  }
};

export default connect(
  mapStateToProps,
  { updatePage, selectSort, updateResults }
)(Table)
